import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetOfferRequestConditionsLatest } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery.ts';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys.ts';

// TODO: Extend with other sources in the future
export const useOfferRequestConditionsLatest = (leadId: string) => {
    const queryKey = queryKeys.getOfferRequestConditionsLatest(leadId);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: { loanRequestId: leadId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getOfferRequestConditionsLatest,
        schema: schemaLoanRequestResolver_GetOfferRequestConditionsLatest,
        searchParams: { id: leadId, position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
